<template>
	<div class="d-flex justify-content-between align-items-center">
		<div>
			<template v-if="brand === 'Visa'">
				<img src="/assets/img/visa.svg" alt="Visa" />
			</template>
			<template v-else-if="brand === 'MasterCard'">
				<img src="/assets/img/mastercard.svg" alt="MasterCard" />
			</template>
			<template v-else-if="brand === 'Amex'">
				<img src="/assets/img/amex.svg" alt="American Express" />
			</template>
			<template v-else>
				{{ brand }}
			</template>
		</div>
		<div>
			<span class="text-muted">**** **** ****</span>
			{{ lastFour }}
		</div>
	</div>
</template>

  <script>
	export default {
		props: {
			brand: {
				type: String,
				required: true,
			},
			lastFour: {
				type: String,
				required: true,
			},
		}
	}
  </script>
